<template>
  <div class="goods-detail-wrap">
    <div class="translation-btn">
      <div class="translation-content">
        <img src="@/assets/images/product/img-translation.png" />
        <span>{{ $t('product.translationTips') }}</span>
      </div>
    </div>
    <div class="goods-detail" v-html="goods.description" @click="clickEvent($event)"></div>

    <ImageTranslation ref="imageTranslationRef" />
  </div>
</template>
<script setup>
import { inject, ref } from 'vue'
import ImageTranslation from './ImageTranslation.vue'

const goods = inject('goods')
const imageTranslationRef = ref()

const clickEvent = (event) => {
  if (event.target.nodeName === 'IMG') {
    const link = event.target.src
    imageTranslationRef.value.openModal(link)
  }
}
</script>
<style scoped lang="scss">
.goods-detail-wrap {
  padding: 20px 0;
  width: 660px;
  position: relative;

  .translation-btn {
    position: sticky;
    top: 160px;
    border-radius: 8px;
    background: var(--primary-color);
    padding: 8px;
    display: inline-block;
    margin-bottom: 20px;
    margin-left: 20px;

    .translation-content {
      display: flex;
      align-items: center;
      color: var(--white-color-1);
      font-size: 12px;
    }

    img {
      height: 16px;
      height: 16px;
      margin-right: 6px;
    }
  }
}

.goods-detail {
  color: var(--black-color-9);

  ::v-deep {
    * {
      max-width: 660px !important;
    }

    img {
      cursor: pointer;
    }
  }

  li {
    width: 100%;
  }

  span,
  p {
    word-break: break-all;
  }

  .attrs {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;

    li {
      width: 100%;
    }

    span,
    p {
      word-break: break-all;
    }

    .attrs {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 30px;

      li {
        display: flex;
        margin-bottom: 10px;
        width: 50%;

        .dt {
          width: 100px;
          color: #999;
        }

        .dd {
          flex: 1;
          color: #666;
        }
      }
    }

    > img {
      width: 100%;
      cursor: pointer;
    }
  }
}
</style>
